<img class="careerpathcss" [src]="roadmapImage" />
